<template>
  <v-footer
    style="background-color: #191919; color: #BABABA"
    :class="!side ? 'px-7 pt-12' : 'py-3'"
    class="d-block"
    align="center"
    no-gutters
    padless
  >
    <template v-if="!side">
      <v-row class="text-left">
        <v-col cols="12" sm="6">
          <v-img
            :src="require('@/assets/sd-logo-white.svg')"
            :srcset="require('@/assets/sd-logo-white.png')"
            contain
            width="180"
            alt="Logo"
          />
        </v-col>

        <v-col cols="12" sm="3">
          <p v-for="(item, index) in directions" :key="index">
            <router-link :to="item.url" class="link" v-if="item.internal">{{
              item.title
            }}</router-link>
            <a :href="item.url" class="link" v-else target="_blank">{{
              item.title
            }}</a>
          </p>
        </v-col>

        <v-col cols="12" sm="3">
          <p v-for="(product, index) in products" :key="index">
            <a :href="product.url" class="link" target="_blank">{{
              product.name
            }}</a>
          </p>
        </v-col>
      </v-row>

      <v-divider color="white" class="my-6" />

      <v-row>
        <v-col cols="12" md="6" class="text-left">
          <a
            v-for="(social, index) in socials"
            :key="index"
            target="_blank"
            :href="social.handle"
            style="text-decoration:none"
          >
            <v-btn class="ml-2" style="color: #191919" fab depressed x-small>
              <v-icon dark>
                {{ social.icon }}
              </v-icon>
            </v-btn>
          </a>
        </v-col>
        <v-col cols="12" md="6" class="text-left text-md-right">
          <p>
            Copyright &copy; All rights Reserved | Powered by SokoLabs
          </p>
        </v-col>
      </v-row>
    </template>

    <template v-else>
      <a
        v-for="(social, index) in socials"
        :key="index"
        target="_blank"
        :href="social.handle"
        style="text-decoration:none"
      >
        <v-btn class="ml-2" style="color: #191919" fab depressed x-small>
          <v-icon dark>
            {{ social.icon }}
          </v-icon>
        </v-btn>
      </a>
    </template>
  </v-footer>
</template>

<script>
export default {
  name: "PageFooter",

  props: ["side"],

  data: () => ({
    socials: [
      {
        icon: "mdi-instagram",
        handle: "https://www.instagram.com/sokodelivery_/",
      },
      { icon: "mdi-twitter", handle: "https://twitter.com/sokodelivery" },
      { icon: "mdi-facebook", handle: "https://facebook.com/SokoDeliverygh/" },
    ],

    products: [
      { name: "SokoPay", url: "https://sokopay.com/" },
      { name: "SokoShopper", url: "https://sokoshopper.com/" },
      { name: "SokoIndex", url: "https://sokoindex.com/" },
      { name: "WorldSoko", url: "#" },
    ],
    directions: [
      {
        title: "Work with us",
        url: "http://soko-delivery-merchant.netlify.app",
      },
      {
        title: "About us",
        url: "/about",
        internal: true,
      },
      {
        title: "FAQS",
        url: "/faqs",
        internal: true,
      },
      {
        title: "Disclaimer",
        url: "#",
      },
      {
        title: "T&C",
        url: "#",
      },
      {
        title: "Privacy Policy",
        url: "#",
      },
      {
        title: "Contact us",
        url: "#",
      },
    ],
  }),
};
</script>

<style scoped>
.link {
  text-decoration: none;
  color: inherit;
}

.link:hover,
.link:active,
.link:focus {
  text-decoration: underline;
}
</style>
